import { mapState } from 'vuex';
import { required, minLength, between, email } from 'vuelidate/lib/validators'

export default {
    name: 'signupnews',
    props: {
    },

    data : function(){

        return {
            email : '',
            name : '',
            lname : '',
            loading : false,
            error : false,
            success : false
        }

    },

    validations: {
        name: {
            required
        },
        lname: {
            required
        },
        email: {
            required,
            email
        }
    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
    }),

    methods : {
        close : function(){
            this.$emit('close')
        },

        submit : function(){
            console.log('submit!')
            
            this.$v.$touch()

            if (this.$v.$invalid) {

                this.error = true

            } else {

                this.error = false
                this.loading = true

                this.$root.api.wai.user.signupnews({

                    email : this.email,
                    name : this.name + " " + this.lname

                }).then(results => {

                    this.loading = false

                    this.success = true

                    localStorage['signupnews'] = true

                }).catch(e => {
                    console.log(e)

                    this.loading = false
                    this.success = false
                })


            }
        }
    },
}